import React from 'react';
import { Code2 } from 'lucide-react';

const AUTH_MODE = process.env.REACT_APP_AUTH_MODE || "sso";

const DevBadge = () => {
  // Ne pas afficher en mode SSO (production)
  if (AUTH_MODE !== "local") {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="flex items-center gap-2 px-4 py-2 bg-yellow-500/10 border border-yellow-500/40 rounded-full backdrop-blur-sm shadow-lg">
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-yellow-400"></span>
        </span>
        <Code2 className="h-4 w-4 text-yellow-400" />
        <span className="text-yellow-400 text-sm font-medium">
          Mode Développement
        </span>
      </div>
    </div>
  );
};

export default DevBadge;
